<template>
  <div class="pages-knowledge">
    <BundlesPage />
  </div>
</template>

<style scoped lang="scss">
.pages-knowledge {
  padding-top: em($gap-page-title);
  padding-bottom: em(185);

  @include media-breakpoint-down(sm) {
    padding-top: em($gap-page-title-sm);
    padding-bottom: em(95);
  }

  @include bundles-constructor-section {
    &:nth-child(2) {
      margin-bottom: em(129);

      @include media-breakpoint-down(sm) {
        margin-bottom: em(65);
      }
    }
  }
}
</style>
